import { render, staticRenderFns } from "./CreateShareholder.vue?vue&type=template&id=74c6e3c0&scoped=true"
import script from "./CreateShareholder.vue?vue&type=script&lang=js"
export * from "./CreateShareholder.vue?vue&type=script&lang=js"
import style0 from "./CreateShareholder.vue?vue&type=style&index=0&id=74c6e3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6e3c0",
  null
  
)

export default component.exports